import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, GithubIssueViewModel, SupportTicketFilter, SupportTicketSelectItem, SupportTicketViewModel, SupportTicketMetricsViewModel } from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from "primeng/table";
import { TicketsApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate } from "@angular/common";




@Component({
  selector: 'app-tickets-list-component',
  templateUrl: './tickets-list.component.html',
  standalone: false
})
export class TicketsListComponent implements OnInit, AfterViewInit {

  public pageTitle: string = 'Support Tickets';


  selectedItems: SupportTicketViewModel[] | undefined = undefined;
  expandedRows: any = {};


  gitHubIssueVisible: boolean = false;
  loadingGitHubIssue: boolean = false;
  gitHubIssues: GithubIssueViewModel[] | null = null;
  gitHubIssue: GithubIssueViewModel | null = null;
  gitHubComment?: string;
  gitHubSelectedItems: SupportTicketViewModel[] | null = null;

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;

  @ViewChild('dt1') table?: Table;


  loading: boolean = false;


  supportTicketPriorities: any[] = []
  supportTicketTypes: any[] = []
  supportTicketStatuses: any[] = []


  showOnlyAssignedToMe: boolean = false;
  showOnlyWatchedByMe: boolean = false;
  showOnlyPinByMe: boolean = false;
  showUnreadOnly: boolean = false;
  showCriticalOnly: boolean = false;
  showOpenOnly: boolean = true;


  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: TicketsApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      console.info('Loading ', params);
    });

    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);

    this.apiService.GetTicketFilterDropdowns()
      .forEach(
        (result) => {
          if (result.Priorities)
            this.supportTicketPriorities = result.Priorities;
          if (result.Types)
            this.supportTicketTypes = result.Types;
          if (result.Statuses)
            this.supportTicketStatuses = result.Statuses;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });


  }

  ngAfterViewInit(): void {
  }

  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = event || { filters: {} };
      this.filter = Utils.deepClone(this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }



  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  expandAll() {
    this.expandedRows = this.list?.Result.reduce((acc: any, p: any) => (acc[p.ID] = true) && acc, {});
  }

  collapseAll() {
    this.expandedRows = {};
  }

  onRowExpand(event: TableRowExpandEvent) {
    console.debug('onRowExpand', event, this.expandedRows);
  }

  onRowCollapse(event: TableRowCollapseEvent) {
    console.debug('onRowCollapse', event, this.expandedRows);
  }

  selectedAll() {
    this.selectedItems = this.list?.Result;
  }

  selectedNone() {
    this.selectedItems = [];
  }

  onSelectionChange(event: any) {
  }

  getSupportTicketTypeClass(item: SupportTicketViewModel | undefined) {

    if (item?.SupportTicketTypeID == 4) //  Urgent
      return 'text-danger fw-bolder bg-dark';
    if (item?.SupportTicketTypeID == 3) // Report a bug
      return 'text-info fw-bolder  ';
    if (item?.SupportTicketTypeID == 1) // General
      return 'text-primary';
    if (item?.SupportTicketTypeID == 2) // How do I...?
      return 'text-info fst-italic';

    return '';
  }
  getTimeFromNow(date: Date) {
    if ((new Date().getTime()) - (new Date(date).getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(date, 'shortDate', 'en-US');
    }
    return Utils.getTimeFromNow(date);
  }
  formatMountainTime(date: Date) {

    return Utils.formatMountainTime(date);
  }


  showLinkGitHub(item: SupportTicketViewModel | undefined) {

    if (item?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${item?.GitHub_Repository}/issues/${item?.GitHub_IssueNumber}`;
      var w = window.open(url);
      if (!w)
        location.href = url;
      return;
    }

    this.selectedItems = [item!];
    this.showLinkGitHubSelected();

  }

  showLinkGitHubSelected() {

    if (!this.selectedItems || this.selectedItems.length == 0) {
      this.alertService.error('Please select an item first');
      return;
    }


    this.gitHubIssueVisible = true;

    this.gitHubSelectedItems = this.selectedItems;

    if (!this.gitHubIssues) {
      this.loadingGitHubIssue = true;
      this.apiService.GetGitHubIssues()
        .forEach((result) => {
          this.loadingGitHubIssue = false;
          result.splice(0, 0, { title: 'New Issue', number: 0, repository: 'utbs_optomiser' });

          this.gitHubIssues = result;

          var myTitle = (this.selectedItems?.length) ? (this.selectedItems[0].Subject || '') : '';
          var r = result.find(x => x.title && myTitle.startsWith(x.title))
          if (!r)
            r = result[0];

          this.gitHubIssue = r;

        }).catch(
          err => {
            this.loadingGitHubIssue = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    } else {
      var myTitle = (this.selectedItems?.length) ? (this.selectedItems[0].Subject || '') : '';
      var r = this.gitHubIssues.find(x => x.title && myTitle.startsWith(x.title))
      if (r)
        this.gitHubIssue = r;
    }

  }


  linkGitHub() {
    if (!this.gitHubSelectedItems || !this.gitHubSelectedItems.length || !this.gitHubIssue)
      return;
    console.debug(this.gitHubIssue);

    let ids = this.gitHubSelectedItems.map((item) => item.ID || 0);

    this.loading = true
    this.apiService.LinkGitHubIssue({
      body: {
        IDs: ids,
        GitHub_IssueNumber: this.gitHubIssue.number,
        GitHub_Repository: this.gitHubIssue.repository || undefined,
        comment: this.gitHubComment || undefined
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.gitHubIssueVisible = false;
        this.loadTable(null);
        this.alertService.success('Item linked successfully');


        if (!this.gitHubIssue?.number && result.number) {
          var url = `https://github.com/UTBS/${result?.repository}/issues/${result?.number}`;
          var w = window.open(url);
          if (!w)
            location.href = url;
          return;
        }

      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }


  toggleAssignedToMe() {
    this.showOnlyAssignedToMe = !this.showOnlyAssignedToMe;

    if (!this.filter)
      this.filter = { filters: {} };
    if (this.showOnlyAssignedToMe) {
      this.filter.filters.IsAssignedToUser = [{ value: 'true', matchMode: 'contains', operator: 'and' }];
    }
    else if (this.filter.filters.IsAssignedToUser && this.filter.filters.IsAssignedToUser.length > 0) {
      this.filter.filters.IsAssignedToUser[0].value = null;
    }
    this.loadTable(null);
  }

  toggleWatchedByMe() {
    this.showOnlyWatchedByMe = !this.showOnlyWatchedByMe;

    if (!this.filter)
      this.filter = { filters: {} };
    if (this.showOnlyWatchedByMe  ) {
      this.filter.filters.IsWatchingByUser = [{ value: 'true', matchMode: 'contains', operator: 'and' }];
    }
    else if (this.filter.filters.IsWatchingByUser && this.filter.filters.IsWatchingByUser.length > 0) {
      this.filter.filters.IsWatchingByUser[0].value = null;
    }
    this.loadTable(null);
  }

  togglePinByMe() {
    this.showOnlyPinByMe = !this.showOnlyPinByMe;

    if (!this.filter)
      this.filter = { filters: {} };
    if (this.showOnlyPinByMe) {
      this.filter.filters.IsPinnedByUser = [{ value: 'true', matchMode: 'contains', operator: 'and' }];
    }
    else if (this.filter.filters.IsPinnedByUser && this.filter.filters.IsPinnedByUser.length > 0) {
      this.filter.filters.IsPinnedByUser[0].value = null;
    }
    this.loadTable(null);
  }



  toggleUnreadOnly() {
    this.showUnreadOnly = !this.showUnreadOnly;

    if (!this.filter)
      this.filter = { filters: {} };
    if (this.showUnreadOnly) {
      this.filter.filters.UnreadCount = [{ value: '0', matchMode: 'gt', operator: 'and' }];
    }
    else if (this.filter.filters.UnreadCount && this.filter.filters.UnreadCount.length > 0) {
      this.filter.filters.UnreadCount[0].value = null;
    }
    this.loadTable(null);
  }

  toggleCriticalOnly() {
    this.showCriticalOnly = !this.showCriticalOnly;

    if (!this.filter)
      this.filter = { filters: {} };
    if (this.showCriticalOnly) {
      this.filter.filters.IsCritical = [{ value: 'true', matchMode: 'contains', operator: 'and' }];
    }
    else if (this.filter.filters.IsCritical && this.filter.filters.IsCritical.length > 0) {
      this.filter.filters.IsCritical[0].value = null;
    }
    this.loadTable(null);
  }

  toggleOpenOnly() {
    this.showOpenOnly = !this.showOpenOnly;

    if (!this.filter)
      this.filter = { filters: {} };
    if (this.showOpenOnly) {
      this.filter.filters.DateClosed = [{ value: 'D0', matchMode: 'isNull', operator: 'and' }];
    }
    else if (this.filter.filters.DateClosed && this.filter.filters.DateClosed.length > 0) {
      this.filter.filters.DateClosed[0].value = null;
    }
    this.loadTable(null);
  }

}
